import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-link",
  "use": "icon-icon-link-usage",
  "viewBox": "0 0 11.8 13.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.8 13.2\" id=\"icon-icon-link\"><title>资源 123</title><g id=\"icon-icon-link_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-link_图层_1-2\" data-name=\"图层 1\"><path d=\"M9.7.7A4.6,4.6,0,0,0,3.4,2.1l-1,1.4L4.5,4.9,5,4.1a2.1,2.1,0,0,1,2.8-.6h.1a2.1,2.1,0,0,1,.6,2.8L8,7.1l2.1,1.4L11,7A4.5,4.5,0,0,0,9.7.7Z\" /><path d=\"M7.1,8.5l-.4.6a2.1,2.1,0,0,1-2.8.6h0a2,2,0,0,1-.6-2.8l.3-.6L1.5,5,.7,6.2a4.6,4.6,0,0,0,1.4,6.3,4.5,4.5,0,0,0,6.3-1.3l.8-1.3Z\" /><rect x=\"3.2\" y=\"5.5\" width=\"5.4\" height=\"2.21\" rx=\"1.1\" ry=\"1.1\" transform=\"translate(-2.9 8) rotate(-57.3)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-link.svg
// module id = sqHv
// module chunks = 71